/*
  These icons are intended to be viewed on our customers pages, they can
  be used on app pages as well, but they have slightly weird positioning
  in order to maintain backward compatibility with how zfe icons 
  are originally positioned on customer pages.

  If you need an icon which is in fontawesome you can get its SVG from
  https://github.com/encharm/Font-Awesome-SVG-PNG/tree/master/white/svg
  (Put the .svg in the `zoomforth_iconfonts/zf-app-modern-files` folder.)

  WARNING!!!

  Some customer themes have come to be dependent on the ordering of the 
  glyphs in font output. Therefore you MUST ensure that the ordering of the 
  output glyphs does not change. The ordering is determined by alphabetization
  so therefore all the icons added herein must be prefixed with a string
  which comes later in the alphabet.

  TODO: Fix this in a more elegant way!

*/

import './external_modern_icons.less';

import 'zoomforth_iconfonts/zf-external-modern.font.js';

import classNames from 'classnames';
import React from 'react';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const Icon_ViewerVersion1 = ({ ident, name, spin, className, ...props }) => (
  <i
    className={classNames(
      'zfe-icon',
      `zfe-name-${name ? name : ident}`,
      `zfe-icon-${ident}`,
      {
        'zfe-spin': spin
      },
      className
    )}
    {...props}
  />
);

const Icon_ViewerVersion2 = ({ ident, name, spin, className, ...props }) => (
  <span
    aria-hidden={true}
    className={classNames(
      'zfe-icon',
      `zfe-name-${name ? name : ident}`,
      `zfe-icon-${ident}`,
      {
        'zfe-spin': spin
      },
      className
    )}
    {...props}
  />
);

export const Icon = (props) => (
  <SiteViewerVersionComponentSelector>
    <Icon_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <Icon_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export const ArrowCircleLeftIcon = props =>
  <Icon ident="arrow-circle-left" {...props} />;

export const ArrowCircleRightIcon = props =>
  <Icon ident="arrow-circle-right" {...props} />;

export const ChevronLeftIcon = props =>
  <Icon ident="arrow-left" {...props} />;

export const ChevronRightIcon = props =>
  <Icon ident="arrow-right" {...props} />;

export const CircleIcon = props =>
  <Icon ident="circle" {...props} />;

export const CloseIcon = props =>
  <Icon ident="close" {...props} />;

export const DownloadIcon = (props) =>
  <Icon ident="download" {...props} />;

export const ExpandIcon = (props) =>
  <Icon ident="expand" {...props} />;

export const ExternalLinkIcon = (props) =>
  <Icon ident="link" name="external-link" {...props} />;

export const FacebookIcon = (props) =>
  <Icon ident="facebook-square" {...props} />;

export const FileIcon = props =>
  <Icon ident="file-o" {...props} />;

export const FileImageIcon = props =>
  <Icon ident="file-image-o" {...props} />;

export const FilePdfIcon = props =>
  <Icon name="pdf" ident="file-pdf-o" {...props} />;

export const FilePowerPointIcon = props =>
  <Icon ident="file-powerpoint-o" {...props} />;

export const FileVideoishIcon = props =>
  <Icon ident="file-video-o" {...props} />;

export const FilterIcon = props =>
  <Icon ident="filter" {...props} />;

export const FormIcon = props =>
  <Icon ident="form" {...props} />;

export const FullscreenIcon = props =>
  <Icon ident="arrows-alt" {...props} />;

export const GearIcon = (props) =>
  <Icon ident="gear" {...props} />;

export const GooglePlusIcon = (props) =>
  <Icon ident="google-plus-square" {...props} />;

export const GlassdoorIcon = (props) =>
  <Icon ident="glassdoor" {...props} />;

export const InstagramIcon = (props) =>
  <Icon ident="instagram" {...props} />;

export const InternalLinkIcon = (props) =>
  <Icon ident="internal-link" {...props} />;

export const LinkedInIcon = (props) =>
  <Icon ident="linkedin-square" {...props} />;

export const ListIcon = (props) =>
  <Icon ident="list" {...props} />;

export const MenuIcon = props =>
  <Icon ident="menu" {...props} />;

export const PDFIcon = (props) =>
  <Icon ident="pdf-text" name="pdf" {...props} />;

export const PlayIcon = (props) =>
  <Icon ident="play" {...props} />;

export const RefreshIcon = props =>
  <Icon ident="refresh" {...props} />;

export const SearchIcon = props =>
  <Icon ident="search" {...props} />;

export const TextIcon = props =>
  <Icon ident="text" {...props} />;

export const TumblrIcon = (props) =>
  <Icon ident="tumblr-square" {...props} />;

export const TwitterIcon = (props) =>
  <Icon ident="twitter-square" {...props} />;

export const WebPreviewIcon = props =>
  <Icon ident="web-preview" {...props} />;

export const YoutubeIcon = (props) =>
  <Icon ident="youtube" {...props} />;

// HACK: Due to poor practices in theme CSS design we need to maintain ordering 
// of the OUTPUT file which automatically sorts by the "glyph" name which is
// actually determined by the filename of the input svg. Which is why these
// are thusly named.
//
// (Please note that the placement of these files *here* at the end of *this* file
// has NO EFFECT on there position in the output file.)

export const CircleClosedIcon = props =>
  <Icon name="circle-closed" ident="zz00hack-circle-closed" {...props} />;

export const AuthenticatorAppIcon = props =>
  <Icon name="authenticator-app" ident="zz00hack-authenticator-app" {...props} />;

export const MobileIcon = props =>
  <Icon name="mobile" ident="zz00hack-mobile" {...props} />;

export const ImageIcon = props =>
  <Icon ident="image" {...props} />;

export const TileIcon = props =>
  <Icon ident="tile" {...props} />;

export const VideoPlayIcon = props =>
  <Icon ident="video-play" {...props} />;

export const ChevronCircleDownIcon = props =>
  <Icon ident="chevron-circle-down" {...props} />;

export const ChevronCircleUpIcon = props =>
  <Icon ident="chevron-circle-up" {...props} />;

export const LoadingIcon = props =>
  <Icon name="loading" ident="circle-o-notch" spin {...props} />;

export const ArrowCircleUpIcon = props =>
  <Icon ident="arrow-circle-up" {...props} />;

export const CheckCircleIcon = props =>
  <Icon ident="zz00hack-check-circle" {...props} />;

export const WarningIcon = props =>
  <Icon name="warning" ident="zz00hack-exclamation-circle" {...props} />;

export const PauseIcon = props =>
  <Icon name="pause" ident="zz00hack-pause" {...props} />;

export const StopIcon = props =>
  <Icon name="stop" ident="zz00hack-stop" {...props} />;

export const HideIcon = props =>
  <Icon name="hide" ident="zz00hack-hide" {...props} />;

export const ShowIcon = props =>
  <Icon name="show" ident="zz00hack-show" {...props} />;
